import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=6ecaf946&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=6ecaf946&prod&lang=scss"
import style1 from "./menu.vue?vue&type=style&index=1&id=6ecaf946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecaf946",
  null
  
)

export default component.exports